import axios from "axios";

let logoutCallback: (() => Promise<void>) | null = null;

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/accounts/${process.env.REACT_APP_ACCOUNT_ID}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Response interceptor to handle 401 errors
instance.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  async (error) => {
    // Check if it's a 401 Unauthorized error
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Limpiar cache de React Query si está disponible
      if (window.queryClient) {
        window.queryClient.clear();
      }

      // Execute logout callback if available
      if (logoutCallback) {
        try {
          await logoutCallback();
        } catch (logoutError) {
          console.error("Error during automatic logout:", logoutError);
          // Fallback: forzar recarga de página
          window.location.reload();
        }
      } else {
        // Fallback: forzar recarga de página
        window.location.reload();
      }
    }

    // Always reject the promise to let the original error handling continue
    return Promise.reject(error);
  }
);

const setBaseURL = (url: string): void => {
  instance.defaults.baseURL = url;
};

const setToken = (token: string): void => {
  instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

const setLogoutCallback = (callback: () => Promise<void>): void => {
  logoutCallback = callback;
};

const transformAxiosError = (error: Error) => {
  if (axios.isAxiosError(error)) {
    return {
      message:
        error.response?.data?.error.errorMessage ||
        error.response?.data?.message ||
        error.message,
      error: error.response?.data?.error || "Unknown error",
    };
  }
  return error;
};

const isAxiosAuthorized = (): boolean => {
  return !!instance.defaults.headers.common["Authorization"];
};

export {
  instance as axios,
  setBaseURL,
  setToken,
  setLogoutCallback,
  transformAxiosError,
  isAxiosAuthorized,
};
